import script from "./submit-property.vue?vue&type=script&setup=true&lang=js"
export * from "./submit-property.vue?vue&type=script&setup=true&lang=js"

import "./submit-property.vue?vue&type=style&index=0&id=5790e4f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5790e4f4"]])

export default __exports__